export class FilterListUserProjectINModel {
  codiceArmadio: string
  codiceCentrale: string
  comune: string
  emailUtente: string
  statoLavorazione: string
}